export const config = {
  // apiBaseUrl: process.env?.['NX_PUBLIC_API_BASE_URL'] || 'http://localhost:8080',

  rtkCacheTimeout: process.env?.['NX_PUBLIC_RTK_CACHE_TIMEOUT'] ? +process.env?.['NX_PUBLIC_RTK_CACHE_TIMEOUT'] : 0,
  assetServiceBaseUrl: process.env?.['NX_PUBLIC_API_BASE_URL'] || 'http://localhost:8080',
  apiV2BaseUrl: process.env?.['NX_PUBLIC_CLATTER_API_V2_URL'] || 'http://localhost:8081', // node api for handling users endpoints
  ngSitesBaseUrl: process.env?.['NX_PUBLIC_SITES_URL'] || 'http://localhost:3011',
  defaultFetchInterval: 1000, // polling for thumbnails
  defaultDebounce: 500,
  slideMutationDebounce: 2000, // 1 second
  pollingTimeout: 120000, // 2 minutes
  presentationBuildPollingTimeout: 1200000, // 20 minutes
  maxCategoriesDepth: 10,
  maxRequestsLimit: 14,

  etl: {
    maxDocumentBuildLimit: 100,
  },

  auth: {
    realm: process.env?.['NX_PUBLIC_AUTH0_CONNECTION_NAME'] || 'Username-Password-Authentication',
    domain: process.env?.['NX_PUBLIC_AUTH0_DOMAIN'],
    clientID: process.env?.['NX_PUBLIC_AUTH0_CLIENT_ID'],
    audience: process.env?.['NX_PUBLIC_AUTH0_AUDIENCE'],
    scope: 'openid profile email',
    responseType: 'token id_token',
    loginUrl: process.env?.['NX_PUBLIC_APP_ROOT_DOMAIN'],
  },

  // this should be removed left only because "PresentationsManager"
  // (which is left as reference as well) component needs it
  rootFoldersIds: {
    slidesRepository: 1,
    presentations: 2,
    assets: 3,
  },
  temp: {
    projectBaseUrl: '/my-workspace/projects',
  },
};
